import React, { useId } from "react";

const iconClass = "w-[27px] h-[27px]";

export const ProjectsIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29.676"
    height="23.956"
    viewBox="0 0 29.676 23.956"
    className={className || iconClass}
    fill="currentColor"
    aria-hidden
  >
    <path
      id="Path_131"
      data-name="Path 131"
      d="M28.87,6.631H27.147V4.517a1.25,1.25,0,0,0-1.25-1.25H12.718a1.25,1.25,0,0,1-.994-.492L9.982.493A1.25,1.25,0,0,0,8.989,0H1.25A1.25,1.25,0,0,0,0,1.252V22.708a1.249,1.249,0,0,0,1.25,1.25H26.068a1.02,1.02,0,0,0,.939-.676,1.13,1.13,0,0,0,.06-.214l.079-.437L29.663,7.65a.849.849,0,0,0-.793-1.019m-24.191,0a.824.824,0,0,0-.793.71s.445,13.149-.875,13.3S1.533,5.261,1.533,5.261a.308.308,0,0,1,.308-.308H25.305a.308.308,0,0,1,.308.308v1.37Z"
      transform="translate(0 -0.002)"
      fill="currentColor"
    />
  </svg>
);

export const TrackAuditsIcon = ({ className }: { className?: string }) => {
  const clipId = useId();
  return (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30.663"
    height="30.508"
    viewBox="0 0 30.663 30.508"
    className={className || iconClass}
    fill="currentColor"
    aria-hidden
  >
    <defs>
      <clipPath id={clipId}>
        <rect
          id="Rectangle_6"
          data-name="Rectangle 6"
          width="30.663"
          height="30.508"
          transform="translate(0 0)"
          fill="currentColor"
        />
      </clipPath>
    </defs>
    <g id="Group_10" data-name="Group 10" transform="translate(0 0.003)">
      <g
        id="Group_9"
        data-name="Group 9"
        transform="translate(0 -0.003)"
        clipPath={`url(#${clipId})`}
      >
        <path
          id="Path_136"
          data-name="Path 136"
          d="M29.967,26.449l-6.375-6.375a12.889,12.889,0,1,0-3.331,3.389l6.346,6.346a2.376,2.376,0,1,0,3.36-3.36m-9.4-17.441v4.312a.914.914,0,0,1-1.828,0V11.214l-4.3,4.3a.914.914,0,0,1-1.292,0l-2.241-2.241L6.769,17.413A.914.914,0,0,1,5.477,16.12l4.788-4.788a.914.914,0,0,1,1.292,0L13.8,13.573l3.652-3.652H15.346a.914.914,0,1,1,0-1.828H19.7l.021,0,.023,0,.027,0,.017,0,.029,0,.015,0,.029.006.015,0,.028.007.016,0,.026.008.017.006.023.009.02.008.02.008.022.01.017.008.024.012.014.008.025.014.013.008.025.016.013.009.024.017.014.011.021.016.018.015.016.014q.034.03.064.064l.014.016.015.018.017.021.011.014.017.024.009.012.016.025.008.013.014.025.008.014.012.024.008.016.01.022.008.019.008.02.009.023.006.018.008.025,0,.016.007.028,0,.015.006.029,0,.015c0,.01,0,.019,0,.029s0,.012,0,.017,0,.018,0,.027,0,.016,0,.023,0,.014,0,.021S20.571,8.992,20.571,9.007Z"
          transform="translate(0 0.003)"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
  );
};

export const ReportsIcon = ({ className }: { className?: string }) => {
  const clipId = useId();
  return (
  <svg
    id="Group_8"
    data-name="Group 8"
    xmlns="http://www.w3.org/2000/svg"
    width="23.535"
    height="29.953"
    viewBox="0 0 23.535 29.953"
    className={className || iconClass}
    fill="currentColor"
    aria-hidden
  >
    <defs>
      <clipPath id={clipId}>
        <rect
          id="Rectangle_5"
          data-name="Rectangle 5"
          width="23.535"
          height="29.953"
          fill="currentColor"
        />
      </clipPath>
    </defs>
    <g id="Group_7" data-name="Group 7" clipPath={`url(#${clipId})`}>
      <path
        id="Path_133"
        data-name="Path 133"
        d="M17.116,9.628a3.213,3.213,0,0,1-3.209-3.209V0H4.279A4.284,4.284,0,0,0,0,4.279v21.4a4.284,4.284,0,0,0,4.279,4.279H19.256a4.284,4.284,0,0,0,4.279-4.279V9.628ZM5.349,8.558H10.7a1.07,1.07,0,0,1,0,2.14H5.349a1.07,1.07,0,1,1,0-2.14M18.186,21.4H5.349a1.07,1.07,0,1,1,0-2.139H18.186a1.07,1.07,0,1,1,0,2.139m0-5.349H5.349a1.07,1.07,0,1,1,0-2.139H18.186a1.07,1.07,0,1,1,0,2.139"
        fill="currentColor"
      />
      <path
        id="Path_134"
        data-name="Path 134"
        d="M321.066,6.036a1.068,1.068,0,0,0-.232-.349L315.487.34a1.071,1.071,0,0,0-1.827.755V4.3a3.213,3.213,0,0,0,3.209,3.209h3.209a1.07,1.07,0,0,0,.987-1.478"
        transform="translate(-297.614 -0.026)"
        fill="currentColor"
      />
    </g>
  </svg>
  );
};

export const HelpIcon = ({ className }: { className?: string }) => {
  const clipId = useId();
  return (
  <svg
    id="Group_26"
    data-name="Group 26"
    xmlns="http://www.w3.org/2000/svg"
    width="27.396"
    height="27.399"
    viewBox="0 0 27.396 27.399"
    className={className || iconClass}
    fill="currentColor"
    aria-hidden
  >
    <defs>
      <clipPath id={clipId}>
        <rect
          id="Rectangle_35"
          data-name="Rectangle 35"
          width="27.396"
          height="27.399"
          fill="#989898"
        />
      </clipPath>
    </defs>
    <g id="Group_26-2" data-name="Group 26" clipPath={`url(#${clipId})`}>
      <path
        id="Path_180"
        data-name="Path 180"
        d="M27.36,26.166,25.7,20.292a13.709,13.709,0,1,0-5.669,5.549l6.161,1.526a.959.959,0,0,0,.233.031.968.968,0,0,0,.933-1.231M14.768,19.886a1.09,1.09,0,0,1-.07.217,1.109,1.109,0,0,1-.1.2,1.189,1.189,0,0,1-.321.321,1.255,1.255,0,0,1-.2.1,1.094,1.094,0,0,1-.217.066,1.117,1.117,0,0,1-.228.023,1.153,1.153,0,0,1-.817-.341,1.026,1.026,0,0,1-.251-.375,1.094,1.094,0,0,1-.07-.217,1.144,1.144,0,0,1-.023-.228,1.169,1.169,0,0,1,.341-.821,1.081,1.081,0,0,1,.178-.143,1.286,1.286,0,0,1,.2-.108,1.354,1.354,0,0,1,.217-.066,1.115,1.115,0,0,1,.453,0,1.336,1.336,0,0,1,.217.066,1.235,1.235,0,0,1,.38.251,1.335,1.335,0,0,1,.143.178.968.968,0,0,1,.1.2,1.09,1.09,0,0,1,.07.217,1.36,1.36,0,0,1,0,.457m.705-5.871-.334.4a1.514,1.514,0,0,0-.35.967v.267a1.162,1.162,0,0,1-2.323,0v-.267a3.839,3.839,0,0,1,.885-2.45l.338-.406c.979-1.173,1.648-2.071,1.339-2.944a1.481,1.481,0,0,0-.711-.766A1.54,1.54,0,0,0,13.2,8.7a1.322,1.322,0,0,0-.918,1.135,1.162,1.162,0,0,1-2.314-.2A3.619,3.619,0,0,1,12.514,6.48a3.839,3.839,0,0,1,2.866.272,3.781,3.781,0,0,1,1.838,2.055c.776,2.189-.741,4.006-1.744,5.209"
        transform="translate(0 0.001)"
        fill="#989898"
      />
    </g>
  </svg>
  );
};

export const UsersIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className || iconClass}
    fill="currentColor"
    aria-hidden
  >
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z" />
  </svg>
);

export const LogoutIcon = ({ className }: { className?: string }) => {
  const clipId = useId();
  return (
  <svg
    id="Group_25"
    data-name="Group 25"
    xmlns="http://www.w3.org/2000/svg"
    width="25.401"
    height="31.151"
    viewBox="0 0 25.401 31.151"
    className={className || iconClass}
    fill="currentColor"
  >
    <defs>
      <clipPath id={clipId}>
        <rect
          id="Rectangle_34"
          data-name="Rectangle 34"
          width="25.401"
          height="31.151"
          fill="#989898"
        />
      </clipPath>
    </defs>
    <g id="Group_25-2" data-name="Group 25" clipPath={`url(#${clipId})`}>
      <path
        id="Path_176"
        data-name="Path 176"
        d="M434.446,72.793q.118-.011.238-.011a2.618,2.618,0,0,1,1.666.605V66.5a.952.952,0,0,0-.952-.952h-5.284v1.9h4.332Z"
        transform="translate(-413.663 -63.037)"
        fill="#989898"
      />
      <path
        id="Path_177"
        data-name="Path 177"
        d="M434.446,543.5v5.344h-4.332v1.9H435.4a.952.952,0,0,0,.952-.952v-6.929a2.531,2.531,0,0,1-1.691.642c-.072,0-.143,0-.213-.009"
        transform="translate(-413.663 -522.105)"
        fill="#989898"
      />
      <path
        id="Path_178"
        data-name="Path 178"
        d="M417.168,296.94c0-.027-.007-.054-.012-.081,0-.008,0-.017,0-.025-.006-.032-.014-.063-.023-.094l0-.01c-.009-.032-.021-.063-.033-.093l0-.008c-.012-.029-.025-.057-.039-.085l-.006-.013c-.013-.025-.028-.05-.044-.074l-.011-.019c-.015-.023-.032-.045-.048-.066l-.015-.021q-.034-.042-.072-.08l-2.4-2.425-.846-.856a1.155,1.155,0,0,0-.819-.343,1.121,1.121,0,0,0-.117.007h-.009a1.062,1.062,0,0,0-.6.267,1.1,1.1,0,0,0-.045,1.589l.53.537.868.878a0,0,0,0,1,0,.006h0l-.865-.006-5.2-.034v2.2l5.2.034.848.005a0,0,0,0,1,0,.006l-.85.841-.534.527a1.132,1.132,0,0,0-.03,1.586,1.094,1.094,0,0,0,.669.316h0q.053.005.107.005a1.1,1.1,0,0,0,.773-.317l.918-.907,2.388-2.361h0a1.111,1.111,0,0,0,.137-.165l0-.006c.018-.028.036-.056.052-.086l0,0a1.1,1.1,0,0,0,.081-.194h0c.01-.034.019-.068.026-.1,0-.006,0-.012,0-.018.006-.029.011-.058.014-.088s.006-.073.006-.109a1.094,1.094,0,0,0,0-.11"
        transform="translate(-391.772 -281.453)"
        fill="#989898"
      />
      <path
        id="Path_179"
        data-name="Path 179"
        d="M13.984.215a.952.952,0,0,0-.791-.2L.764,2.526A.952.952,0,0,0,0,3.459V27.692a.952.952,0,0,0,.764.933l12.429,2.507a.952.952,0,0,0,1.14-.933V.952a.952.952,0,0,0-.349-.737M10.559,16.708a.952.952,0,0,1-1.9,0V14.443a.952.952,0,1,1,1.9,0Z"
        fill="#989898"
      />
    </g>
  </svg>
  );
};
